export default __webpack_public_path__ + "static/media/F0003.59078824.png";